import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../../styles";
import StatusLead from "../../../status";
import { getFarolColors } from "../../constants";

interface Props {
  farolAtualizacao: string;
  mensagemFarolAtualizacao: string;
}

export const ExpiraEmCell: React.FC<Props> = ({
  farolAtualizacao,
  mensagemFarolAtualizacao,
}) => (
  <Tooltip
    followCursor
    title={mensagemFarolAtualizacao || "--"}
    placement="top-start"
    arrow
  >
    <Styles.Td>
      <StatusLead
        backgroundColor={getFarolColors(farolAtualizacao, "background")}
        color={getFarolColors(farolAtualizacao, "text")}
        status={mensagemFarolAtualizacao || "--"}
      />
    </Styles.Td>
  </Tooltip>
);
